import {
  TOGGLE_EXPORT_MODE, TOGGLE_EDIT_MODE, TOGGLE_CARD_VIEW, TOGGLE_CUSTOMIZE_MODE,
  TOGGLE_MODAL_EDIT_MODE, TOGGLE_SELECT_MODE,
  SAVE_TABLE_COLUMN_SETTINGS, SAVE_TABLE_COLUMN_SETTINGS_SUCCESS, SAVE_TABLE_COLUMN_SETTINGS_ERROR,
} from '../../../constants/system/actions';
import LocalStorageService from '../../../services/local-storage-service';

const controlsReducer: Reducer = (
  state: ReducerState = {
    isExportMode: false,
    isEditMode: false,
    isCustomizeMode: false,
    isCardView: LocalStorageService.hasCardViewValue() ? LocalStorageService.getCardViewValue() : false,
    isModalEditMode: false,
    isSelectMode: false,
    isTableLoading: false,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case TOGGLE_EXPORT_MODE:
      return {
        ...state,
        isExportMode: action.payload,
      };
    case TOGGLE_EDIT_MODE:
      return {
        ...state,
        isEditMode: action.payload,
      };
    case TOGGLE_CUSTOMIZE_MODE:
      return {
        ...state,
        isCustomizeMode: action.payload,
      };
    case TOGGLE_CARD_VIEW:
      LocalStorageService.setCardViewValue(action.payload);

      return {
        ...state,
        isCardView: action.payload,
      };
    case TOGGLE_MODAL_EDIT_MODE:
      return {
        ...state,
        isModalEditMode: action.payload,
      };
    case TOGGLE_SELECT_MODE:
      return {
        ...state,
        isSelectMode: action.payload,
      };
    case SAVE_TABLE_COLUMN_SETTINGS:
      return {
        ...state,
        isTableLoading: true,
      };
    case SAVE_TABLE_COLUMN_SETTINGS_SUCCESS:
      return {
        ...state,
        isTableLoading: false,
      };
    case SAVE_TABLE_COLUMN_SETTINGS_ERROR:
      return {
        ...state,
        isTableLoading: false,
      };
    default:
      return state;
  }
};

export default controlsReducer;
